/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/bonz/modules/errorNotification.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'bonz/modules/errorNotification', exports: {} }; const exports = module.exports;

const Selectors = {
    CONTAINER: '#error-notification-container',
    TEXT: '#error-notification-msg',
    INNER: '#error-notification-inner',
}
const Styles = {
    HIDE: 'hide'
}
const Attribs = {
    EXPANDED: 'aria-expanded',
    HIDDEN: 'aria-hidden',
}
function toggle(isVisible, msg) {
    const container = document.querySelector(Selectors.CONTAINER);
    if (!isVisible) {
        container.classList.add(Styles.HIDE);
    }
    else {
        container.classList.remove(Styles.HIDE);
        document.querySelector(Selectors.TEXT).innerText = msg;
    }
    container.setAttribute(Attribs.EXPANDED, isVisible);
    document.querySelector(Selectors.INNER).setAttribute(Attribs.HIDDEN, !isVisible);
}
export default {
    show(msg) {
        if (!msg) {
            return;
        }
        toggle(true, msg);
    },
    hide() {
        toggle(false);
    }
};